import { Button } from 'antd';
import styled from 'styled-components';

const ActionCell = styled(Button)`
  padding: 0 24.5px;
  text-shadow: none;
  color: #f8b117;
  background: transparent;
  border-color: #f8b117;
  border-radius: 12px;
  height: 38px;
  &:hover,
  &:focus {
    border-color: #f8b117;
    color: #f8b117;
    background-color: transparent;
  }
`;

export default ActionCell;
